<template>
  <div class="container">
    <div class="userinfo">
      <el-badge :is-dot="commentCount > 0" class="item">
        <el-button
          size="medium"
          @click="
            redirectTo('comment');
            setCommentRead();
          "
          >评论</el-button
        >
      </el-badge>
      <el-badge :value="refundCount" class="item">
        <el-button size="medium" @click="redirectTo('refund')">退款</el-button>
      </el-badge>
      <el-badge :value="troubleCount" class="item">
        <el-button size="medium" @click="redirectTo('fault')">报障</el-button>
      </el-badge>
      <el-badge :value="receiptRequestCount" class="item">
        <el-button size="medium" @click="redirectTo('receipt')">发票</el-button>
      </el-badge>
      <span style="margin:0 10px">今日退款率：{{ refundRate }}</span>
      <i class="el-icon-user"></i>
      <el-divider direction="vertical"></el-divider>
      <el-dropdown>
        <span class="el-dropdown-link">
          {{ name }}<i class="el-icon-arrow-down el-icon--right"></i>
        </span>
        <el-dropdown-menu slot="dropdown">
          <el-dropdown-item
            icon="el-icon-edit"
            @click.native="openPasswordPanel"
            >修改密码</el-dropdown-item
          >
        </el-dropdown-menu>
      </el-dropdown>
      <el-button type="info" @click="logout">退出</el-button>
    </div>
    <el-form>
      <div class="mask" v-if="isPasswordOpen">
        <div class="password-container">
          <el-input
            type="password"
            placeholder="请输入原密码"
            v-model.trim="oldPassword"
            size="mini"
            prefix-icon="el-icon-key"
          />
          <el-input
            type="password"
            placeholder="请输入新密码"
            maxlength="16"
            v-model.trim="newPassword"
            size="mini"
            prefix-icon="el-icon-key"
          />
          <el-input
            type="password"
            placeholder="请再次输入新密码"
            maxlength="16"
            v-model.trim="repeatPassword"
            size="mini"
            prefix-icon="el-icon-key"
          />
          <div>
            <el-button type="info" @click="submitPassword" size="mini" round
              >确定</el-button
            >
            <el-button
              type="info"
              @click="isPasswordOpen = false"
              style="margin-left:18px;"
              size="mini"
              round
              >取消</el-button
            >
          </div>
        </div>
      </div>
    </el-form>
  </div>
</template>

<script>
// import Cookies from "js-cookie";
import { mapState } from "vuex";
export default {
  data() {
    return {
      oldPassword: "",
      newPassword: "",
      repeatPassword: "",
      isPasswordOpen: false,
      commentCount: "",
      refundCount: "",
      troubleCount: "",
      receiptRequestCount: "",
      refundRate: "0%"
    };
  },
  methods: {
    logout() {
      this.$confirm("是否确定退出?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      })
        .then(() => {
          let urlName = "注销";
          this.$axios(this.$urlMapping[urlName]).then(() => {
            localStorage.removeItem("userInfo");
            this.$router.replace({ name: "login" });
          });
        })
        .catch(() => {});
    },

    getCount() {
      let params = {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          token: this.$getToken()
        }
      };
      //查询订单restful API
      fetch(
        this.$urlMapping["查询订单"],
        Object.assign(params, {
          body: JSON.stringify({
            orderStatus: 30, //申请退款
            pageNum: 1,
            pageSize: 100
          })
        })
      )
        .then(response => response.json())
        .then(data => {
          let { result } = data;
          if (result.data.length == 0) {
            this.refundCount = "";
          } else if (result.data.length >= 100) {
            this.refundCount = "99+";
          } else {
            this.refundCount = result.data.length;
          }
        })
        .catch(e => console.log("Failure, error", e));
      //查询机器故障restful API
      fetch(
        this.$urlMapping["查询机器故障"],
        Object.assign(params, {
          body: JSON.stringify({
            status: 0,
            pageNum: 1,
            pageSize: 100
          })
        })
      )
        .then(response => response.json())
        .then(data => {
          let { result } = data;
          if (result.data.length == 0) {
            this.troubleCount = "";
          } else if (result.data.length >= 100) {
            this.troubleCount = "99+";
          } else {
            this.troubleCount = result.data.length;
          }
        })
        .catch(e => console.log("Failure, error", e));

      let strUserInfo = localStorage.getItem("userInfo");
      if (!strUserInfo) {
        return;
      }
      let userInfo = JSON.parse(strUserInfo);

      if (userInfo.user_type == "admin") {
        //查询机器故障restful API
        fetch(
          this.$urlMapping["查询发票申请"],
          Object.assign(params, {
            body: JSON.stringify({
              receiptStatus: 0,
              pageNum: 1,
              pageSize: 100
            })
          })
        )
          .then(response => response.json())
          .then(data => {
            let { result } = data;
            if (result.data.length == 0) {
              this.receiptRequestCount = "";
            } else if (result.data.length >= 100) {
              this.receiptRequestCount = "99+";
            } else {
              this.receiptRequestCount = result.data.length;
            }
          })
          .catch(e => console.log("Failure, error", e));

        fetch(this.$urlMapping["查询未读评论"], Object.assign(params))
          .then(response => response.json())
          .then(x => {
            if (x.code == 0) {
              this.commentCount = x.result.length;
              //this.commentCount = 0;
            }
          });

        this.$axios(this.$urlMapping["查询退款率"], {}).then(x => {
          if (x) {
            console.log(x);
            this.refundRate = (x * 100).toFixed(2) + "%";
          }
        });
      }
    },

    redirectTo: function(val) {
      this.$router.push({
        name: val
      });
    },

    setCommentRead() {
      this.commentCount = 0;
      this.$axios(this.$urlMapping["评论置已读"], {
        data: {}
      }).then(() => {
        this.$notifySuccess("评论置已读");
      });
    },

    autoRefresh: function() {
      setInterval(this.getCount, 5 * 60 * 1000);
      this.getCount();
    },

    openPasswordPanel() {
      this.oldPassword = this.newPassword = this.repeatPassword = "";
      this.isPasswordOpen = true;
    },
    submitPassword() {
      if (
        this.newPassword === "" ||
        this.oldPassword === "" ||
        this.repeatPassword === ""
      ) {
        this.$notify.error({
          title: "错误",
          message: "输入框不能为空"
        });
        return;
      }
      if (this.newPassword !== this.repeatPassword) {
        this.$notify.error({
          title: "错误",
          message: "新密码输入不一致"
        });
        return;
      }
      if (
        !/^.*(?=.{6,16})(?=.*[0-9a-zA-Z]{1,})(?=.*[!@#$%^&*?()]).*$/.test(
          this.newPassword
        )
      ) {
        this.$notify.error({
          title: "错误",
          message: "密码必须6-16位，至少包含1个特殊字符(!@#$%^&*)"
        });
        return;
      }
      this.$axios(this.$urlMapping["修改密码"], {
        data: {
          oldPassword: this.oldPassword,
          newPassword: this.newPassword
        }
      }).then(() => {
        this.$alert("密码修改成功，请退出系统重新登录", "提示", {
          confirmButtonText: "确定",
          callback: () => {
            this.$axios(this.$urlMapping["注销"]).then(() => {
              localStorage.removeItem("userInfo");
              this.$router.replace({ name: "login" });
            });
          }
        });
      });
    }
  },
  computed: {
    name() {
      let strUserInfo = localStorage.getItem("userInfo");
      if (!strUserInfo) {
        return;
      }
      let userInfo = JSON.parse(strUserInfo);
      if (userInfo) {
        return userInfo[userInfo.user_type];
      } else {
        return "";
      }
    },
    userType() {
      let strUserInfo = localStorage.getItem("userInfo");
      if (!strUserInfo) {
        return;
      }
      let userInfo = JSON.parse(strUserInfo);
      return userInfo.user_type;
    },
    ...mapState(["userInfo"])
  },

  mounted() {
    this.autoRefresh();
  }
};
</script>

<style lang="less" scoped>
.container {
  height: 64px;
  background: #545c64;
  color: white;
  .userinfo {
    float: right;
    margin-right: 12px;
    margin-top: 12px;
    display: flex;
    align-items: center;
    .el-icon-user {
      font-size: 24px;
    }
    .name {
      font-size: 20px;
      margin: 0 18px;
    }

    .item {
      margin: 0 18px;
    }
  }
  .el-dropdown-link {
    color: white;
    font-size: 20px;
    margin: 0 18px;
  }
  .mask {
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    z-index: 1000;
    display: flex;
    justify-content: flex-end;
    .password-container {
      box-sizing: border-box;
      width: 240px;
      height: 180px;
      padding: 0 24px;
      background: #545c64;
      margin-top: 64px;
      display: flex;
      flex-direction: column;
      justify-content: space-around;
      align-items: center;
    }
  }
}
</style>
